import React from "react";
import { Layout } from "antd";

const Footer = () => {
    const { Footer } = Layout;
    return <Footer>&copy; 2020. CWA Admin Panel</Footer>;
};

export default Footer;
